import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const JobSelection = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));

export const JobSelectionContainer = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "4px",
}));

export const ContentReferenceText = styled("span")(() => ({
  color: colors.gray800,
  fontSize: "22px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "28px",
  marginRight: "12px",
  fontFamily: "Manrope",
}));
